import { render, staticRenderFns } from "./Cropper.vue?vue&type=template&id=65b53001&"
import script from "./Cropper.vue?vue&type=script&lang=js&"
export * from "./Cropper.vue?vue&type=script&lang=js&"
import style0 from "./Cropper.vue?vue&type=style&index=0&id=65b53001&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports